"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Connect = void 0;
var react_1 = __importDefault(require("react"));
var react_cookie_1 = require("react-cookie");
var const_1 = require("remota-common/const");
var structure_1 = require("remota-client/component/structure");
var panel_1 = require("remota-client/component/panel");
var form_1 = require("remota-client/component/form");
var button_1 = require("remota-client/component/button");
var icon_1 = require("remota-client/component/icon");
var auth_1 = require("app/hook/auth");
var Connect = function (props) {
    var _a = __read(react_1.default.useState({
        tenantCode: "",
        userCode: "",
        credential: "",
    }), 2), query = _a[0], setQuery = _a[1];
    var setCookie = (0, react_cookie_1.useCookies)([const_1.TOKEN_COOKIE_NAME])[1];
    var _b = __read((0, auth_1.useAuthenticate)(), 3), token = _b[0], authenticate = _b[1], status = _b[2];
    var handleChange = react_1.default.useCallback(function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setQuery(function (query) {
            var _a;
            return (__assign(__assign({}, query), (_a = {}, _a[name] = value, _a)));
        });
    }, [setQuery]);
    var handleSubmit = react_1.default.useCallback(function () { return authenticate(query); }, [query, authenticate]);
    var handleKeyDown = react_1.default.useCallback(function (e) {
        // IME変換確定のEnterは無視する
        if (e.key !== "Enter" || e.nativeEvent.isComposing || status.isLoading || status.isLoaded) {
            return;
        }
        handleSubmit();
    }, [handleSubmit, status.isLoading, status.isLoaded]);
    if (token && !status.error && !status.isLoading) {
        // TODO: 有効期限など
        setCookie(const_1.TOKEN_COOKIE_NAME, token, { path: "/" });
        window.location.assign("".concat(props.location.pathname).concat(props.location.search));
    }
    var error = status.error !== null;
    return (react_1.default.createElement(structure_1.PlainStructure, { center: true },
        react_1.default.createElement(panel_1.LogoPanel, { width: 360 },
            react_1.default.createElement("h2", null, "\u30D5\u30A1\u30FC\u30B9\u30C8\u30A2\u30AB\u30A6\u30F3\u30C6\u30A3\u30F3\u30B0 - Concur \u9023\u643A"),
            react_1.default.createElement(structure_1.FormLineStructure, { label: "Remota\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u304A\u6301\u3061\u306E\u5834\u5408" },
                react_1.default.createElement(form_1.BoxInput, { type: "text", name: "tenantCode", value: query.tenantCode, onChange: handleChange, onKeyDown: handleKeyDown, error: error, placeholder: "\u30C6\u30CA\u30F3\u30C8\u30B3\u30FC\u30C9" })),
            react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(form_1.BoxInput, { type: "text", name: "userCode", value: query.userCode, onChange: handleChange, onKeyDown: handleKeyDown, error: error, placeholder: "\u30E6\u30FC\u30B6\u30FCID" })),
            react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(form_1.BoxInput, { type: "password", name: "credential", value: query.credential, onChange: handleChange, onKeyDown: handleKeyDown, error: error, placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9" })),
            react_1.default.createElement(structure_1.FormLineStructure, null,
                react_1.default.createElement(button_1.AccentButton, { thin: true, disabled: status.isLoaded, onClick: handleSubmit, width: "100%" }, "\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u30A2\u30AB\u30A6\u30F3\u30C8\u9023\u643A\u3059\u308B")),
            react_1.default.createElement(structure_1.FormLineStructure, { label: "Remota\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u304A\u6301\u3061\u3067\u306A\u3044\u5834\u5408" },
                react_1.default.createElement(button_1.IconButton, { icon: icon_1.check, href: "/", target: "_blank" }, "\u554F\u3044\u5408\u308F\u305B\u308B")),
            react_1.default.createElement("div", null,
                react_1.default.createElement("div", null,
                    react_1.default.createElement("a", { href: "/privacy", target: "_blank" }, "\u30D7\u30E9\u30A4\u30D0\u30B7\u30FC\u30DD\u30EA\u30B7\u30FC")),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("a", { href: "/terms", target: "_blank" }, "\u5229\u7528\u898F\u7D04"))))));
};
exports.Connect = Connect;
